import iconSystem from "../../../../assets/icon_system.svg";

// 시스템 메시지 컴포넌트
const SystemMessage = ({ message }) => (
  <div className="px-5 py-4 bg-white rounded-[30px] border border-violet-50 justify-start items-start gap-3.5 inline-flex w-full">
    <div className="shrink-0">
      <img src={iconSystem} alt="" />
    </div>
    <p className="text-base font-medium leading-snug whitespace-pre-line text-neutral-600">
      {message}
    </p>
  </div>
);

export default SystemMessage;
